import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import BootstrapMenuBar from "./components/menu/BootstrapMenuBar";
import TSExpert from "./components/ts-expert/TSExpert";
import LiveList from "./components/LiveList";
import LiveListMatrix from "./components/LiveListMatrix";
import Oscilloscope from "./components/Oscilloscope";
import Oscilloscope2 from "./components/Oscilloscope2";
import BarGraph from "./components/BarGraph";
import OpticFiber from "./components/olm/OpticFiber";
import EventLog from "./components/EventLog";
import Report from "./components/login-config/Report";
import Configuration from "./components/login-config/Configuration";
import Login from "./components/login-config/Login";
import LoginHandler from "./components/login-config/LoginHandler";
import ChangeLogin from "./components/login-config/ChangeLogin";
import WLANConfig from "./components/login-config/WLANConfig";
import EthernetConfig from "./components/login-config/EthernetConfig";
import TsExpertConfig from "./components/login-config/TsExpertConfig";
import SegmentDevices from "./components/login-config/SegmentDevices";
import ActiveChannels from "./components/login-config/ActiveChannels.js";
import ChannelsTime from "./components/login-config/ChannelsTime.js";
import DevicesChannels from "./components/login-config/DevicesChannels.js";
import OpticFiberConfig from "./components/login-config/OpticFiberConfig.js";
import EventLogOLM from "./components/olm/EventLogOLM";

import Constants from "./components/utilities/Constants";
import Utils from "./components/utilities/Utils";

const UtilsInstance = new Utils();

class App extends Component {

  retrieveData = async () => {
    let fiveChannels = await fetch(Constants.REQUEST_IP_ADDRESS + "scopeType", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.fiveChannels)
      .catch((e) => {
        console.log("Request problem: ", e);
        return false;
      });

    let isFiberProcessOn = await fetch(Constants.REQUEST_IP_ADDRESS + "fiber/isFiberProcessOn", { mode: "cors" })
      .then(UtilsInstance.checkStatus)
      .then(res => res.json())
      .then(data => data.isFiberProcessOn)
      .catch((e) => {
        console.log("Request problem: ", e);
        return false;
      });

    let requireReload = false;

    if (sessionStorage.getItem("fiveChannels") === null || String(fiveChannels) !== sessionStorage.getItem("fiveChannels")) {
      requireReload = true;
    }

    if (sessionStorage.getItem("isFiberProcessOn") === null || String(isFiberProcessOn) !== sessionStorage.getItem("isFiberProcessOn")) {
      requireReload = true;
    }

    sessionStorage.setItem("fiveChannels", fiveChannels);
    sessionStorage.setItem("isFiberProcessOn", isFiberProcessOn);

    if (requireReload) {
      window.location.reload();
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = async () => {
    this.retrieveData();
    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      let language = await fetch(Constants.REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.language);

      localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
      window.location.reload();
    }
  }

  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <BootstrapMenuBar />
          <Switch>
            <Route exact path="/" component={TSExpert} />
            <Route exact path="/live-list" component={LiveList} />
            <Route path="/live-list-matrix" component={LiveListMatrix} />
            <Route path="/oscilloscope" component={Oscilloscope} />
            <Route path="/oscilloscope2" component={Oscilloscope2} />
            <Route path="/bar-graph" component={BarGraph} />
            <Route path="/optic-fiber" component={OpticFiber} />
            <Route path="/optic-fiber-log" component={EventLogOLM} />
            <Route path="/log" component={EventLog} />
            <Route path="/config" component={Configuration} />
            <Route path="/login" component={Login} />
            <Route path="/login-handler" component={LoginHandler} />
            <Route path="/change-login" component={ChangeLogin} />
            <Route path="/report" component={Report} />
            <Route path="/wlan-config" component={WLANConfig} />
            <Route path="/ethernet-config" component={EthernetConfig} />
            <Route path="/ts-expert-config" component={TsExpertConfig} />
            <Route path="/segment-devices" component={SegmentDevices} />
            <Route path="/active-channels" component={ActiveChannels} />
            <Route path="/channels-time" component={ChannelsTime} />
            <Route path="/devices-channels" component={DevicesChannels} />
            <Route path="/optic-fiber-config" component={OpticFiberConfig} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
